const TEXT = {
  Unknown: 'Unknown',
};

export { TEXT };
